import UI from './libs/ui'

var LogicTab = function (editor) {

  var signals = editor.signals;

  var container = new UI.Panel();
  container.setId('logicTab');

  //

  var selectedNode = null;

  function build() {

    container.clear();

    if (selectedNode === null) return;


    //default checked is 'Random'
    let checkedNode = selectedNode.data.logicNodeType || 'Random'
    editor.signals.logicNodeTypeChanged.dispatch(checkedNode)

    function onLogicNodeTypeChange(e) {      
      let value = e.target.value
      editor.signals.logicNodeTypeChanged.dispatch(value)
    }

    // Random
    var row = new UI.Row();
    var radio = new UI.Radio("Random", "logic", checkedNode === "Random");
    radio.onChange(onLogicNodeTypeChange)
    row.add(radio);
    container.add(row);
    
    // Specific
    var row = new UI.Row();
    var radio = new UI.Radio("Specific", "logic", checkedNode === "Specific");
    radio.onChange(onLogicNodeTypeChange)
    var scenesCollectionContainer = new UI.Div();
    var selectedNodeLinksTo = selectedNode.diagram.model.linkDataArray.filter(linkData => linkData.from === selectedNode.data.key)
    var linkedNodes = selectedNodeLinksTo.map(node => selectedNode.diagram.model.nodeDataArray[node.to]).filter(node => {
      if (typeof node !== 'undefined') {
        node.category == "Scene"
      }      
    })
    
    linkedNodes.forEach((linkedNode, i) => {
      var titleContainer = new UI.Div();
      let nodePercent = parseFloat(selectedNodeLinksTo.find(node => node.to === linkedNode.key).text)
      var percentInput = new UI.Number(nodePercent).setData("key", linkedNode.key);

      var text = new UI.Span();
      text.dom.innerText = linkedNode.title
      titleContainer.add(text)
      titleContainer.add(percentInput)
      scenesCollectionContainer.add(titleContainer)

      percentInput.onChange(function(e) {
        let key = parseInt(e.target.dataset.key)
        let links = selectedNode.findLinksOutOf()
        let remainingPercent = 100
        let newPercent = parseFloat(e.target.value)
        // let oldPercent = parseFloat(selectedNode.diagram.model.linkDataArray[key].text)
      
        let percentToDistrubeEvenly = (remainingPercent - newPercent) / (linkedNodes.length - 1)
      
        links.each(link => {
          let newPercent = e.target.value

          if (link.data.text && link.data.to == key) {
            link.data.text = newPercent + '%'
          } else if (link.data.text) {
            link.data.text = percentToDistrubeEvenly + '%'
            document.querySelector(`input[data-key="${link.data.to}"]`).value = percentToDistrubeEvenly
          }
          
          link.updateTargetBindings()
          
        })    
      })
    })

    row.add(radio);
    row.add(scenesCollectionContainer)
    container.add(row);

    // Conditional
    var row = new UI.Row();
    var radio = new UI.Radio("Conditional", "logic", checkedNode === "Conditional");
    radio.onChange(onLogicNodeTypeChange)
    row.add(radio);
    container.add(row);

  }


  //

  // signals.editorCleared.add( function () {

  // 	selected = null;
  // 	build();

  // } );

  signals.nodeSelected.add(function (node) {    
    if (node.data.category === 'Logic') {      
      selectedNode = node;
      build();
    }
  });

  // signals.effectCompiled.add(build);

  /*
  signals.timeChanged.add( function () {

  	if ( selected !== null ) {

  		for ( var key in values ) {

  			values[ key ].setValue( selected.module.parameters[ key ].value );

  		}

  	}

  } );
  */

  return container;

};

export default LogicTab



//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/LogicTab.js
// module id = null
// module chunks = 